import CrmIntegrationsListing from "../../components/CrmIntegrationsListing/CrmIntegrationsListing";

const Integrations = () => {
  return <CrmIntegrationsListing />;
};

export default Integrations;
